<script setup lang="ts">
import { RouterView } from 'vue-router'
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'

const authStore = useAuthStore()

onMounted(() => {
  // Initialize auth state from localStorage
  authStore.loadFromStorage()
})
</script>

<template>
  <RouterView />
</template>

<style>
/* Global styles are in style.css */
</style>
